export const GATEWAY_FETCH_TIMEOUT_MS = 15000
